import { useState } from 'react';
import "./LoginPage.css";
import { Formik } from 'formik';
import axios from 'axios';
import { site_url } from "../config.js";

function Index() {
  const [msg, setMsg] = useState([]);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    console.log(values);
    try {
     
      const response = await axios.post(site_url+'/create_account', values);
   
      if(response.data.status === 'success'){
        setMsg(response.data)
       
        resetForm();
      }else if(response.data.status === 'failed'){
        setMsg(response.data)
      }
       // Reset form after success
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false); // Stop loading spinner
    }
  };

  return (
    <div className="login-container">
      <div className="login-header">
        <img
          src="https://static.vecteezy.com/system/resources/previews/001/082/517/non_2x/digital-marketing-concept-store-front-vector.jpg" // Replace with your truck image URL
          alt="Truck"
          className="header-image"
        />
      </div>
      <div className="login-form">
      <Formik
       initialValues={{ phone: '', password: '', username: '' }}
       validate={values => {
         const errors = {};
         if (!values.phone) {
           errors.phone = 'Phone Number is required';
         }else if (!/^\d{10}$/.test(values.phone)) {
            errors.phone = 'Phone number must be exactly 10 digits';
          }
         if (!values.password) {
            errors.password = 'Password is required';
          }
          if (!values.username) {
            errors.username = 'Username is required';
          }
         return errors;
       }}
       onSubmit={handleSubmit}
     >
       {({
         values,
         errors,
         touched,
         handleChange,
         handleBlur,
         handleSubmit,
         isSubmitting,
         /* and other goodies */
       }) => (
      <form onSubmit={handleSubmit}>
        <h2>Create a New Account</h2>
        {msg.status === 'success' && (
        <div class="alert alert-success mb-1" role="alert">
        Account successfully created
        </div>
        )}
         {msg.status === 'failed' && (
        <div class="alert alert-danger mb-1" role="alert">
       Phone number already exists
        </div>
        )}

        <div className="form-group">
          <label htmlFor="Username">
            <i className="fa fa-user"></i>
          </label>
          <input type="text" id="text" placeholder="Enter Your User Name" name="username"  onChange={handleChange} onBlur={handleBlur} value={values.username} />
        </div>
        {errors.username && touched.username &&(<span className="error">{errors.username}</span>)}
        <div className="form-group">
          <label htmlFor="email">
            <i className="fa fa-phone"></i>
          </label>
          <input type="number" id="email" placeholder="Enter Your Mobile Number" name="phone"  onChange={handleChange} onBlur={handleBlur} value={values.phone} />
        </div>
        {errors.phone && touched.phone &&(<span className="error">{ errors.phone}</span>)}
        <div className="form-group">
          <label htmlFor="password">
            <i className="fa fa-lock"></i>
          </label>
          <input type="number" id="password" placeholder="M-Pin or Password" name="password" onChange={handleChange} onBlur={handleBlur} value={values.password} />
          <i className="fa fa-eye toggle-password"></i>
        </div>
        {errors.password && touched.password &&(<span className="error">{ errors.password}</span>)}
        <button  type="submit" disabled={isSubmitting} className="login-button">{isSubmitting ? 'Submitting...' : 'Sign up'}</button>
   
      </form>
       )}
       </Formik>
      </div>
    </div>
  );
}

export default Index;
